import propTypes from 'prop-types';
import classnames from 'classnames'
import { withStyles } from '@material-ui/core';
import styles from './styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import ArrowRightBlack from 'assets/images/arrow-right-black.svg';
import { useCallback, useMemo, useRef, useState } from 'react';
import WorklogDetailsCard from 'pages/ScheduleV6/components/card/WorklogDetailsCard';
import { useHandleDrop } from 'pages/ScheduleV6/components/events/hooks/useHandleResourceDrop';
import { getSheetEventTitle } from 'pages/ScheduleV6/utils';

const CrewLeaderEventCardV6 = ({
  classes,
  event,
  handleClick,
  noClSheets,
}) => {
  const popperRef = useRef(null);
  const cardRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const sheet = useMemo(() => event.extendedProps?.sheet, [event]);

  const { handleDrop } = useHandleDrop({
    sheet: sheet,
  });

  const open = Boolean(anchorEl);

  const handleExpandClick = useCallback((event) => {
    event.stopPropagation();
    setAnchorEl(cardRef?.current);
  }, [cardRef, setAnchorEl]);

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        <Card
          className={classnames(
            "schedule-v6-event-card", "cl",
            classes.clEventCard,
            {
              [classes.nightShiftEventCard]: sheet.timeOfDay === 'Night',
              [classes.publishError]: noClSheets.includes(sheet._id),
            },
          )}
          ref={cardRef}
          onClick={handleClick}
        >
          <div className={classes.expandIconWrapper}>
            <span className={classes.expandIconBase} onClick={handleExpandClick}>
              <img src={ArrowRightBlack} className={classes.iconImage} alt="arrow" />
            </span>
            {event?.extendedProps?.locationColor ? (
              <div
                className={classes.locationMark}
                style={{ borderTopColor: event?.extendedProps?.locationColor, borderRightColor: event?.extendedProps?.locationColor }}
              />
            ) : null}
          </div>
          <div className={classes.jobNumberWrapper}>
            {sheet.project?.jobNumber ? (
              <span className={classes.jobNumber}>#{sheet.project.jobNumber}</span>
            ) : null}
          </div>
          <div className={classes.titleWrapper}>
            <Typography variant="h6" color="textPrimary" style={{ display: 'flex' }}>
              {getSheetEventTitle(sheet, 'short')}
            </Typography>
          </div>
          <div className={classes.contractorWrapper}>
            <Typography variant="body1" color="textSecondary" style={{ display: 'flex' }}>
              {sheet.project?.contractor?.name}
            </Typography>
          </div>
        </Card>

        <Popper
          id={sheet._id}
          ref={popperRef}
          open={open}
          anchorEl={anchorEl}
          placement={'right-start'}
          className={classnames(classes.popper)}
          flip={false}
          popperRef={(node) => {
            popperRef.current = node;
          }}
          style={{ zIndex: 999 }}
          modifiers={{
            flip: {
              enabled: false,
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: 'viewport',
            },
          }}
        >
          <div
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
          >
            <WorklogDetailsCard sheet={sheet} close={handleClose}/>
          </div>
        </Popper>
      </div>
    </ClickAwayListener>
  )
}

CrewLeaderEventCardV6.propTypes = {
  classes: propTypes.object,
  event: propTypes.object.isRequired,
  locationColor: propTypes.string,
  handleClick: propTypes.func.isRequired,
  noClSheets: propTypes.arrayOf(propTypes.string),
}

export default withStyles(styles)(CrewLeaderEventCardV6)